import PageHeader from "@/components/PageHeader";
import { BookMarked, ExternalLink, ScrollText } from "lucide-react";

const publications = [
  {
    title:
      "La invisibilización de las mujeres asesinas seriales: un análisis psicológico-forense",
    journal: "Revista LATAM · Estudios Latinoamericanos",
    editor: "Redilat",
    volume: "Vol. VII · N.º 1 (2026)",
    issn: "ISSN en línea: 2789-3855",
    doi: "DOI: 10.56712",
    authors: "Katia Marcin Olascoaga · Gerardo Abadía León · Rocío Carrasco Hernández",
    tag: "Artículo indexado",
    href: "https://revistalatam.redilat.org/index.php/lt/article/view/5338",
  },
];

const Colecciones = () => {
  return (
    <div data-testid="colecciones-page">
      <PageHeader
        eyebrow="05 · Publicaciones"
        title="Publicaciones académicas."
        subtitle="Nuestras contribuciones a la investigación en psicología clínica y forense, revisadas por pares."
      />

      {/* Publicaciones académicas */}
      <section className="px-6 md:px-14 pb-6">
        <div className="mb-6 flex items-center gap-3">
          <BookMarked size={18} style={{ color: "var(--p-burgundy)" }} strokeWidth={1.4} />
          <p className="eyebrow" style={{ color: "var(--p-burgundy)" }}>
            Publicaciones académicas
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6">
          {publications.map((p, i) => (
            <a
              key={i}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`publication-${i}`}
              className="card-soft group relative flex flex-col md:flex-row overflow-hidden"
              style={{ background: "#fbf6ec" }}
            >
              {/* Left band */}
              <div
                className="md:w-64 shrink-0 p-6 md:p-8 relative"
                style={{
                  background:
                    "linear-gradient(180deg, var(--p-burgundy), var(--p-burgundy-deep))",
                  color: "var(--p-cream)",
                }}
              >
                <div className="absolute inset-x-6 top-4 rule-gold" />
                <div className="absolute inset-x-6 bottom-4 rule-gold" />
                <ScrollText size={22} style={{ color: "var(--p-gold-soft)" }} strokeWidth={1.3} />
                <div
                  className="mt-4"
                  style={{
                    fontFamily: "Cinzel Decorative, serif",
                    fontSize: "1.2rem",
                    letterSpacing: "0.04em",
                    lineHeight: 1.2,
                    color: "var(--p-gold-soft)",
                  }}
                >
                  Revista<br />LATAM
                </div>
                <div
                  className="mt-3 text-[11px] uppercase"
                  style={{ fontFamily: "Cinzel, serif", letterSpacing: "0.22em", opacity: 0.85 }}
                >
                  {p.volume}
                </div>
              </div>
              {/* Body */}
              <div className="flex-1 p-6 md:p-8">
                <div className="flex items-center justify-between">
                  <span
                    className="px-3 py-1 rounded-full text-[10px]"
                    style={{
                      background: "rgba(184,151,90,0.18)",
                      color: "var(--p-burgundy)",
                      fontFamily: "Cinzel, serif",
                      letterSpacing: "0.16em",
                      textTransform: "uppercase",
                    }}
                  >
                    {p.tag}
                  </span>
                  <ExternalLink
                    size={16}
                    style={{ color: "var(--p-burgundy)" }}
                    className="opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all"
                  />
                </div>
                <h3
                  className="mt-3"
                  style={{
                    fontFamily: '"Times New Roman", "Cormorant Garamond", serif',
                    fontSize: "1.55rem",
                    fontWeight: 600,
                    color: "var(--p-black)",
                    lineHeight: 1.2,
                  }}
                >
                  {p.title}
                </h3>
                <p
                  className="mt-2"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    color: "var(--p-brown)",
                    fontSize: "1.02rem",
                    lineHeight: 1.5,
                    fontStyle: "italic",
                  }}
                >
                  {p.journal}
                </p>
                <p
                  className="mt-1"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    color: "var(--p-black)",
                    fontSize: "1.02rem",
                    lineHeight: 1.5,
                  }}
                >
                  {p.authors}
                </p>
                <div
                  className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3 text-[13px]"
                  style={{ fontFamily: "Cormorant Garamond, serif", color: "var(--p-brown)" }}
                >
                  <MetaRow label="Editorial" value={p.editor} />
                  <MetaRow label="Identificador" value={p.issn} />
                  <MetaRow label="DOI" value={p.doi} />
                </div>
                <div className="mt-6 inline-flex items-center gap-2" style={{ color: "var(--p-burgundy)", fontFamily: "Cormorant Garamond, serif", fontSize: "1rem", fontWeight: 600 }}>
                  Leer artículo completo <ExternalLink size={14} />
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>

      <div className="rule-gold mx-6 md:mx-14 my-14" />

      <section className="px-6 md:px-14 pb-24">
        <div className="max-w-2xl">
          <p className="eyebrow" style={{ color: "var(--p-burgundy)" }}>
            Próximamente
          </p>
          <h2
            className="mt-3"
            style={{
              fontFamily: "Cormorant Garamond, serif",
              fontSize: "clamp(1.6rem, 3vw, 2.2rem)",
              fontWeight: 500,
              color: "var(--p-black)",
            }}
          >
            Más publicaciones e investigaciones.
          </h2>
          <p
            className="mt-3"
            style={{
              fontFamily: "Cormorant Garamond, serif",
              color: "var(--p-brown)",
              fontSize: "1.05rem",
              lineHeight: 1.6,
            }}
          >
            Continuamos investigando y publicando en el campo de la psicología
            clínica y forense. Aquí aparecerán los nuevos artículos revisados
            por pares conforme sean publicados.
          </p>
        </div>
      </section>
    </div>
  );
};

const MetaRow = ({ label, value }) => (
  <div>
    <div
      className="eyebrow"
      style={{ color: "var(--p-brown)" }}
    >
      {label}
    </div>
    <div className="mt-1" style={{ color: "var(--p-black)" }}>
      {value}
    </div>
  </div>
);

export default Colecciones;
